import {
  GET_DETAIL_TABLE_EXCO_PUSAT,
  GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  GET_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  POST_DETAIL_TABLE_EXCO_PUSAT,
  POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  POST_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  PATCH_DETAIL_TABLE_EXCO_PUSAT,
  PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  DELETE_DETAIL_TABLE_EXCO_PUSAT,
  DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS,
  GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL,
  POST_LOCK_UNLOCK_EXCO,
  POST_LOCK_UNLOCK_EXCO_SUCCESS,
  POST_LOCK_UNLOCK_EXCO_FAIL
} from "./actionTypes";

const initialState = {
  dataTableDetailExco: {
    loading: false,
    error: false,
    data: null,
  },
  postTableDetailExco: {
    loading: false,
    error: false,
    data: null,
  },
  patchTableDetailExco: {
    loading: false,
    error: false,
    data: null,
  },
  deleteTableDetailExco: {
    loading: false,
    error: false,
    data: null,
  },
  getDetailTablePengurus: {
    loading: false,
    error: false,
    data: null,
  },
  postLockUnlockExco: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // get detail exco table
    case GET_DETAIL_TABLE_EXCO_PUSAT:
      return {
        ...state,
        dataTableDetailExco: {
          ...state.dataTableDetailExco,
          loading: true,
          error: false,
        },
      };
    case GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        dataTableDetailExco: {
          ...state.dataTableDetailExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_DETAIL_TABLE_EXCO_PUSAT_FAIL:
      return {
        ...state,
        dataTableDetailExco: {
          ...state.dataTableDetailExco,
          loading: false,
          error: action.payload,
        },
      };
    // post detail exco table
    case POST_DETAIL_TABLE_EXCO_PUSAT:
      return {
        ...state,
        postTableDetailExco: {
          ...state.postTableDetailExco,
          loading: true,
          error: false,
        },
      };
    case POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        postTableDetailExco: {
          ...state.postTableDetailExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case POST_DETAIL_TABLE_EXCO_PUSAT_FAIL:
      return {
        ...state,
        postTableDetailExco: {
          ...state.postTableDetailExco,
          loading: false,
          error: action.payload,
        },
      };
    // patch detail exco table
    case PATCH_DETAIL_TABLE_EXCO_PUSAT:
      return {
        ...state,
        patchTableDetailExco: {
          ...state.patchTableDetailExco,
          loading: true,
          error: false,
        },
      };
    case PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        patchTableDetailExco: {
          ...state.patchTableDetailExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL:
      return {
        ...state,
        patchTableDetailExco: {
          ...state.patchTableDetailExco,
          loading: false,
          error: action.payload,
        },
      };
    // delete detail exco table
    case DELETE_DETAIL_TABLE_EXCO_PUSAT:
      return {
        ...state,
        deleteTableDetailExco: {
          ...state.deleteTableDetailExco,
          loading: true,
          error: false,
        },
      };
    case DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        deleteTableDetailExco: {
          ...state.deleteTableDetailExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL:
      return {
        ...state,
        deleteTableDetailExco: {
          ...state.deleteTableDetailExco,
          loading: false,
          error: action.payload,
        },
      };
    // get user detail exco table
    case GET_USER_DETAIL_TABLE_EXCO_PUSAT:
      return {
        ...state,
        getDetailTablePengurus: {
          ...state.getDetailTablePengurus,
          loading: true,
          error: false,
        },
      };
    case GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        getDetailTablePengurus: {
          ...state.getDetailTablePengurus,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL:
      return {
        ...state,
        getDetailTablePengurus: {
          ...state.getDetailTablePengurus,
          loading: false,
          error: action.payload,
        },
      };
    // post lock unlock
    case POST_LOCK_UNLOCK_EXCO:
      return {
        ...state,
        postLockUnlockExco: {
          ...state.postLockUnlockExco,
          loading: true,
          error: false,
        },
      };
    case POST_LOCK_UNLOCK_EXCO_SUCCESS:
      return {
        ...state,
        postLockUnlockExco: {
          ...state.postLockUnlockExco,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case POST_LOCK_UNLOCK_EXCO_FAIL:
      return {
        ...state,
        postLockUnlockExco: {
          ...state.postLockUnlockExco,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
